const pad = (n) => String(n).padStart(2, "0");
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const ymd = (y, m, d) => iso(new Date(y, m, d));

const GETTERS = {
  today: (n) => [iso(n), iso(n)],
  "7d": (n) => [ymd(n.getFullYear(), n.getMonth(), n.getDate() - 6), iso(n)],
  month: (n) => [ymd(n.getFullYear(), n.getMonth(), 1), ymd(n.getFullYear(), n.getMonth() + 1, 0)],
  lastmonth: (n) => [ymd(n.getFullYear(), n.getMonth() - 1, 1), ymd(n.getFullYear(), n.getMonth(), 0)],
  "3m": (n) => [ymd(n.getFullYear(), n.getMonth() - 2, 1), ymd(n.getFullYear(), n.getMonth() + 1, 0)],
  year: (n) => [ymd(n.getFullYear(), 0, 1), ymd(n.getFullYear(), 11, 31)],
};

export const PRESETS = [
  { id: "today", label: "Hari Ini" },
  { id: "7d", label: "7 Hari" },
  { id: "month", label: "Bulan Ini" },
  { id: "lastmonth", label: "Bulan Lalu" },
  { id: "3m", label: "3 Bulan" },
  { id: "year", label: "Tahun Ini" },
  { id: "custom", label: "Custom" },
];

export function presetRange(id) {
  const [start, end] = GETTERS[id](new Date());
  return { preset: id, start, end };
}

const short = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });

export const rangeLabel = ({ start, end }) => {
  if (!start && !end) return "Semua Tanggal";
  if (start === end) return short(start);
  return `${start ? short(start) : "Awal"} – ${end ? short(end) : "Sekarang"}`;
};

export const singleMonth = ({ start, end }) => (start && end && start.slice(0, 7) === end.slice(0, 7) ? start.slice(0, 7) : "");

export const rangeParams = ({ start, end }) => ({ start: start || undefined, end: end || undefined });
